import { some } from 'lodash';
import { useMemo } from 'react';
import { Purchase } from '../../../types/entities.js';

export const useIsSomeLotSmp = (announce: Purchase) =>
  useMemo(() => some(announce.lots, (lot) => lot.isSmp), [announce.lots]);
